import type { UIRouterGlobals } from "@uirouter/angularjs";
import type { IScope } from "angular";
import { cloneDeep, isEqual, sampleSize } from "lodash";
import { finalize } from "rxjs/operators";

import type {
    ICredentials,
    IEquipmentDetails,
    IResponseWithLoading,
    ISiteEquipmentWithCoverages,
} from "App/Modules/Models";
import { CredentialsType } from "App/Modules/Models";
import type { ISiteEquipmentRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditEquipmentCredentialsComponentController {
    public static $inject: string[] = ["$scope", "$uiRouterGlobals", "mmSiteEquipmentRepository"];

    public originalCredentials: ICredentials;

    public credentials: ICredentials;

    public siteId: string;

    public resolve: IFormContainerResolve<IEquipmentDetails, ISiteEquipmentWithCoverages>;

    public patchResponse: IResponseWithLoading<IEquipmentDetails>;

    constructor(
        private readonly $scope: IScope,
        private readonly $uiRouterGlobals: UIRouterGlobals,
        private readonly siteEquipmentRepository: ISiteEquipmentRepository,
    ) {}

    public $onInit() {
        this.originalCredentials = this.resolve.formData.credentials[0];
        if (this.resolve.formData.credentials.length) {
            this.credentials = cloneDeep(this.originalCredentials);
        } else {
            this.credentials = {
                password: this.generatePassword(),
                type: CredentialsType.Admin,
                typeName: CredentialsType[CredentialsType.Admin],
                userName: "admin",
            } as ICredentials;
        }

        this.siteId = this.$uiRouterGlobals.params.siteId;
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public generatePassword(length = 12) {
        const passwordChars = "abcdefghkmnpqrstuvwxyz23456789!#%&()=?-<>";
        return sampleSize(passwordChars, length).join("");
    }

    public editEquipmentCredentials() {
        const patchObject = {
            credentials: [this.credentials],
        } as IEquipmentDetails;

        if (!isEqual(this.credentials, this.originalCredentials)) {
            extendWithLoadingAndFail(
                this.siteEquipmentRepository.patchEquipment(this.siteId, this.resolve.bindings.id, patchObject),
            )
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<IEquipmentDetails>) => {
                        this.patchResponse = response;
                        if (!response.isLoading && response.data) {
                            this.resolve.options.onOk(response.data);
                        }
                    },
                    (error) => {
                        this.patchResponse = error;
                    },
                );
        } else {
            this.cancel();
        }
    }
}
